import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=c5cb6864"
import script from "./Issues.vue?vue&type=script&lang=js"
export * from "./Issues.vue?vue&type=script&lang=js"
import style0 from "./Issues.vue?vue&type=style&index=0&id=c5cb6864&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports